<template>
    <div class="animated fadeIn">

        <!-- Splash section -->
        <section class="hero is-medium has-border-bottom-gray">
            <div class="hero-body">
                <div class="container">
                    <div class="columns is-vcentered">
                        <div class="column has-padding-top-2x-mobile">
                            <div class="columns is-centered is-vcentered contact-us-header-mailbox is-mobile">
                                <div class="column is-narrow padding-top-2x-mobile">
                                    <figure class="image about-us-splash" v-if="!isMobile()">
                                        <img alt="About us, Who we are?" src="./assets/about-us.svg">
                                    </figure>
                                    <figure class="image about-us-splash mobile-screen" v-else>
                                        <img alt="About us, Who we are?" src="./assets/about-us.svg">
                                    </figure>
                                </div>
                            </div>
                            <div class="columns is-centered padding-top-2x">
                                <h1 class="title is-size-2 has-text-centered-mobile padding-bottom-1x uptin-text-center">
                                    {{ $t('about:about_us.title') }}
                                </h1>
                            </div>
                            <div class="columns is-centered">
                                <h2 class="is-size-5 has-text-centered-mobile uptin-text-center small-container">
                                    {{ $t('about:about_us.subtitle') }}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Description section -->
        <section class="section">
            <div>
                <div class="columns is-centered">
                    <div class="column intro-text content">
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7"
                           v-html="$t('about:about_us.description')">
                        </p>
                    </div>
                </div>
                <div class="columns">
                    <div class="column intro-text content small-container padding-bottom-1x" >
                        <p class="is-size-6 small-container uptin-text-center uptin-text-7">
                            {{ $t('about:about_us.description_founded') }}
                        </p>
                    </div>
                </div>
            </div>
        </section>

        <section class="hero is-bold">
            <div class="hero-body has-text-centered">
                <div class="container">
                    <div class="columns is-centered is-vcentered">
                        <div class="column">
                            <router-link to="contact-us" class="uptin-button is-rounded is-size-6 uptin-text-center">
                            <h3 class="title is-size-4 uptin-text-center">
                                {{ $t('about:about_us.become_ambassadors') }}
                            </h3>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="container">
                <div class="content has-text-centered padding-bottom-2x">
                    <h4 class="is-size-3 padding-bottom-3x uptin-text-center" v-html="$t('about:about_us.humans_behind_ob')">
                    </h4>
                </div>
                <ob-team-members/>
            </div>
        </section>

        <download-app></download-app>
        <pay-as-you-go></pay-as-you-go>
    </div>
</template>


<style lang="scss">

    .intro-text {
        max-width: 900px;
    }

    .about-us-splash {
        max-width: 350px;
        min-width: 350px;
        height: auto;

        &.position-top {
            top: -1em;
        }

        &.mobile-screen {
            max-width: 400px;
            min-width: 200px;
        }
    }

</style>


<script>
    import ObTeamMembers from "./components/team-members/team-members"
    import PayAsYouGo from "@/components/pay-as-you-go/pay-as-you-go"
    import DownloadApp from "@/components/download-app/download-app"

    export default {
        components: {
            PayAsYouGo,
            DownloadApp,
            ObTeamMembers
        },
        data() {
            return {
            }
        },
        methods: {
            isMobile() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                }
        }
    }
</script>
